import { render, staticRenderFns } from "./reporting-information.vue?vue&type=template&id=0878cf37&"
import script from "./reporting-information.vue?vue&type=script&lang=ts&"
export * from "./reporting-information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports